import { httpClient } from "../http/httpClient";
import { PartnerType } from "../../utils/partners.enum";

// TODO: Vericar como vai ficar essa rota na Start, tem mudanças comparada a Credliber

type BaseTypes =
  | "BONUS"
  | "LEADER"
  | "REFFERED"
  | "RETROACTIVE"
  | "SELLER"
  | "TRANSACTIONAL"
  | "SUPERVISOR";

type PartneredTypes = `${BaseTypes}_${PartnerType}`;

type ExtractBlocked = {
  [K in BaseTypes | PartneredTypes]?: number;
};
export interface getAvailableAmountResponse {
  amount: number;
  config: {
    withdrawsRemaining: number;
    minWithdrawAmount: number;
    withdrawFee: number;
  };
  extract: {
    BONUS: number;
    LEADER: number;
    REFFERED: number;
    RETROACTIVE: number;
    SELLER: number;
    SUPERVISOR: number;
    TRANSACTIONAL: number;
  };
  // extract: ExtractBlocked; // Credliber
  blocked: ExtractBlocked;
}

export async function getAvailableAmount(id: string) {
  const { data } = await httpClient.get<getAvailableAmountResponse>(
    `/withdraw/${id}`,
  );

  return data;
}
